import React, {memo} from 'react'
import {List, Popup} from 'semantic-ui-react'

const _Features = (props) => {
  const {
    linkText = 'All Features'
  } = props
  return (
    <Popup trigger={<a href='' data-test='features-link'>{linkText}</a>} hoverable>
      <List bulleted data-test='features'>
        <List.Item>Import/Export Swagger/OAS</List.Item>
        <List.Item>CI/CD Support via CLI</List.Item>
        <List.Item>View/Inspect Requests</List.Item>
        <List.Item>Template Responses</List.Item>
        <List.Item>Delay Responses</List.Item>
        <List.Item>Disconnect Responses</List.Item>
        <List.Item>Script Response Behavior</List.Item>
        <List.Item>Weight Response Precedence</List.Item>
        <List.Item>Proxy From Real Services</List.Item>
        <List.Item>Secure Client Access</List.Item>
        <List.Item>Generate & Share API Docs</List.Item>
      </List>
    </Popup>
  )
}

let Features = (props) => {
  return (<_Features {...props}/>)
}

Features = memo(Features)

export {Features, _Features}

export default Features